import React from 'react';
import { useLocale } from '../../context/LocaleContext';
import './LanguageSwitcher.css';

export default function LanguageSwitcher() {
  const { locale, setLocale } = useLocale();

  return (
    <div className="lang-switcher" role="group" aria-label="Language">
      <button
        type="button"
        className={`lang-switcher-btn ${locale === 'ko' ? 'lang-switcher-btn-active' : ''}`}
        onClick={() => setLocale('ko')}
        title="한국어"
        aria-pressed={locale === 'ko'}
      >
        <span className="lang-switcher-flag" aria-hidden>🇰🇷</span>
        <span className="lang-switcher-label">KO</span>
      </button>
      <button
        type="button"
        className={`lang-switcher-btn ${locale === 'en' ? 'lang-switcher-btn-active' : ''}`}
        onClick={() => setLocale('en')}
        title="English"
        aria-pressed={locale === 'en'}
      >
        <span className="lang-switcher-flag" aria-hidden>🇺🇸</span>
        <span className="lang-switcher-label">EN</span>
      </button>
    </div>
  );
}
